export const h = {
  connectYourDevice: '连接你的设备',
  mainTips: '将会在URL栏下方打开一个设备列表，选择一个设备后，点击“连接”按钮即可。',
  presentationMode: '演示模式',
  browserVersionTips: '当前{n}浏览器版本过低，请升级到最新版本！',
  browserVersionTips2: '当前浏览器不支持，请使用最新版Chrome、Edge或Opera浏览器！',
  reconnectedTipsTitle: '检测到设备重新连接，是否跳转到对应设备页面？',
  reconnectedTipsHead: '提示',
  sure: '确定',
  cancel: '取消',
  disconnect: '设备已断开连接！',
  connectFail: '设备连接失败,请插拔设备后重新连接！'

}